import React from "react";
import { useLanguage } from "../../../i18n/LanguageContext";

const ServicesBanner: React.FC = () => {
  const { t, dir } = useLanguage();
  const isRtl = dir === "rtl";

  const content = (t as any)?.servicesHero || {};
  const title =
    content.title ||
    "The full study abroad journey,\nhandled for you.";
  const subtitle =
    content.subtitle ||
    "EduVate covers everything a family needs to get their child into school in Egypt — from the first conversation to graduation.";
  const image = content.image || "/images/services-hero-students.png";

  const sideGradient = isRtl
    ? "linear-gradient(270deg, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.54) 42%, rgba(0,0,0,0.12) 100%)"
    : "linear-gradient(90deg, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.54) 42%, rgba(0,0,0,0.12) 100%)";

  return (
    <section
      className="relative min-h-screen overflow-hidden text-white"
      aria-labelledby="services-hero-title"
      dir={isRtl ? "rtl" : "ltr"}
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('${image}')`,
          backgroundPosition: "center center",
        }}
        aria-hidden="true"
      />

      <div className="absolute inset-0 bg-second-color/20 mix-blend-multiply" />
      <div className="absolute inset-0 bg-black/30" />
      <div className="absolute inset-0" style={{ background: sideGradient }} />

      <div
        className={`site-container relative z-10 flex min-h-screen items-end pb-10 pt-28 sm:pb-14 sm:pt-32 lg:pb-16 ${
          isRtl ? "justify-end text-right" : "justify-start text-left"
        }`}
      >
        <div
          className={`flex w-full max-w-[759px] flex-col gap-6 ${
            isRtl ? "items-end" : "items-start"
          }`}
        >
          <div
            className={`flex w-full flex-col gap-3 ${
              isRtl ? "items-end" : "items-start"
            }`}
          >
            <h1
              id="services-hero-title"
              className="hero-title w-full max-w-[759px] whitespace-pre-line text-white"
            >
              {title}
            </h1>
            <p className="hero-subtitle w-full max-w-[609px] whitespace-pre-line text-white/90">
              {subtitle}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesBanner;
